import { FC } from 'react';

import FeatureTableCell from 'components/Tables/FeatureComparisonTable/components/FeatureTableCell';
import { FeatureComparisonRowProps } from 'components/Tables/FeatureComparisonTable/config';

interface FeatureTableRowPropsExtended extends FeatureComparisonRowProps {
  prismaticHighlighted?: boolean;
  inHouseHighlighted?: boolean;
  traditionalHighlighted?: boolean;
  prismaticColumn: FeatureComparisonRowProps['columnOne'];
  inHouseColumn: FeatureComparisonRowProps['columnOne'];
  traditionalColumn: FeatureComparisonRowProps['columnOne'];
}

const FeatureTableRow: FC<FeatureTableRowPropsExtended> = ({
  rowHeading,
  prismaticColumn,
  inHouseColumn,
  traditionalColumn,
  prismaticHighlighted,
  inHouseHighlighted,
  traditionalHighlighted,
}) => (
  <div className="flex items-stretch justify-between border-b border-white/20 bg-white/5 last:border-b-0">
    <div className="w-[210px] px-4 py-5 md:w-[230px] md:px-6 xl:w-[290px]">
      <span className="leading-6 text-white md:text-xl md:leading-[30px]">{rowHeading}</span>
    </div>

    <div className="flex flex-1 items-stretch justify-start gap-4 md:gap-6 xl:gap-[30px]">
      {/* Prismatic */}
      <div className="relative flex flex-1 items-center justify-start py-5">
        {prismaticHighlighted && (
          <div className="pointer-events-none absolute inset-y-0 -left-5 -right-2 bg-gradient-prismatic opacity-30" />
        )}
        <div className="relative z-10 flex w-full items-center justify-start gap-2.5">
          {prismaticColumn && <FeatureTableCell {...prismaticColumn} />}
        </div>
      </div>

      {/* In-House */}
      <div className="relative flex flex-1 items-center justify-start py-5">
        {inHouseHighlighted && (
          <div className="pointer-events-none absolute inset-y-0 -left-4 -right-1 bg-gradient-prismatic opacity-30" />
        )}
        <div className="relative z-10 flex w-full items-center justify-start gap-2.5">
          {inHouseColumn && <FeatureTableCell {...inHouseColumn} />}
        </div>
      </div>

      {/* Traditional iPaaS */}
      <div className="relative flex flex-1 items-center justify-start py-5">
        {traditionalHighlighted && (
          <div className="pointer-events-none absolute inset-y-0 -left-4 -right-1 bg-gradient-prismatic opacity-30" />
        )}
        <div className="relative z-10 flex w-full items-center justify-start gap-2.5">
          {traditionalColumn && <FeatureTableCell {...traditionalColumn} />}
        </div>
      </div>
    </div>
  </div>
);

export default FeatureTableRow;
